// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"63":"user-agreement","963":"privacy-policy"}[chunkId] + "." + {"63":"6e857e69","963":"576e5129"}[chunkId] + ".css";
};